/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiGiftItem } from './GiftItem';

export interface GiftOrderRequest {

    /**
     * Purchaser's email address
     */
    purchaser_email?: string;

    /**
     * The gateway to use for purchase ('stripe')
     */
    gateway_name?: string;

    /**
     * The transaction ID at the gateway for this gift purchase.
     */
    gateway_transaction_id?: string;

    /**
     * The gateway data as a JSON object
     */
    gateway_data?: string;

    gift_items?: ApiGiftItem[];

}

@Model('GiftOrder')
export class ApiGiftOrder extends BaseModel implements GiftOrderRequest {

    /**
     * Purchaser's email address
     */
    
    
    purchaser_email: string;

    /**
     * The gateway to use for purchase ('stripe')
     */
    
    
    gateway_name: string;

    /**
     * The transaction ID at the gateway for this gift purchase.
     */
    
    
    gateway_transaction_id: string;

    /**
     * The gateway data as a JSON object
     */
    
    
    gateway_data: string;

    @Type('ApiGiftItem')
    @Expand()
    gift_items: ApiGiftItem[];

}
